import { BaseActionObject, StateNodeConfig, assign } from "xstate4"
import {
  Context,
  StudyPlanV2CheckMultipleFiltersTargetSchema,
  Transitions
} from "../../types"
import { BASE_SP_V2_PATH } from "../constants"
import { checkFiltersForMultipleValues } from "../guards"

export const checkSPV2MultipleFiltersTarget: StateNodeConfig<
  Context,
  StudyPlanV2CheckMultipleFiltersTargetSchema,
  Transitions,
  BaseActionObject
> = {
  initial: "idle",
  states: {
    idle: {
      on: {
        UPDATE_REPORTING_FILTERS_STATE: {
          target: BASE_SP_V2_PATH,
          actions: assign((_ctx, event) => {
            return {
              reportingFiltersState: event.state
            }
          }),
          cond: (ctx, evt) =>
            !checkFiltersForMultipleValues(evt.state, ctx.currentTarget)
        }
      }
    }
  }
}
